//@format
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/style.css';
import ErrorBoundary from './components/ErrorBoundary';
import { version } from '../package.json';

window.__version__ = version;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <ErrorBoundary fallback='There was an Error'>
      <App />
    </ErrorBoundary>
    <div style={{ position: 'fixed', bottom: 4, right: 8, fontSize: 10, color: 'rgba(255,255,255,0.5)', zIndex: 9999, pointerEvents: 'none' }}>
      v{version}
    </div>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
